import api from "@api";

export default {
  name: `SlotIntegration`,

  props: {
    clientCode: {
      type: String,
      required: true,
    },
    slotCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      parameter: {
        labelList: [
          {
            provider: `Nexus`,
            fields: [
              { key: `panelUrl`, desc: `Panel URL`, value: null },
              { key: `username`, desc: `Username`, value: null },
              { key: `password`, desc: `Password`, value: null },
            ],
          },
        ],
        registrarList: [
          {
            provider: `Namecheap`,
            fields: [
              { key: `apiUser`, desc: `ApiUser`, value: null, isCredential: true },
              { key: `apiKey`, desc: `ApiKey`, value: null, isCredential: true },
              { key: `username`, desc: `Username`, value: null, isCredential: true },
              { key: `domainPattern`, desc: `Domain Pattern`, value: null, isCredential: false },
              { key: `domainTld`, desc: `Domain TLD`, value: null, isCredential: false },
            ],
          },
        ],
        shortenerList: [
          {
            provider: `T.ly`,
            fields: [
              {
                key: `apiKey`,
                desc: `Api Key`,
                value: null,
                isMandatory: true,
              },
              {
                key: `shortUrl`,
                desc: `Short URL`,
                value: null,
                isMandatory: true,
              },
            ],
          },
        ],
        tldList: [
          { value: `com`, text: `.com` },
          { value: `net`, text: `.net` },
          { value: `org`, text: `.org` },
          { value: `me`, text: `.me` },
          { value: `lol`, text: `.lol` },
          { value: `app`, text: `.app` },
          { value: `xyz`, text: `.xyz` },
          { value: `site`, text: `.site` },
          { value: `online`, text: `.online` },
          { value: `store`, text: `.store` },
          { value: `cyou`, text: `.cyou` },
          { value: `website`, text: `.website` },
          { value: `store`, text: `.store` },
          { value: `shop`, text: `.shop` },
          { value: `quest`, text: `.quest` },
          { value: `click`, text: `.click` },
          { value: `cfd`, text: `.cfd` },
          { value: `autos`, text: `.autos` },
          { value: `makeup`, text: `.makeup` },
          { value: `boats`, text: `.boats` },
          { value: `motorcycles`, text: `.motorcycles` },
          { value: `sbs`, text: `.sbs` },
          { value: `baby`, text: `.baby` },
          { value: `art`, text: `.art` },
        ],
      },
      templateList: [],
      selectedTemplate: null,
      labelIntegration: {
        enabled: false,
        registrarData: null,
        loaderRegistrar: false,
        labelData: null,
        loaderLabel: false,
      },
      shortenerIntegration: {
        enabled: false,
        shortenerData: null,
      },
      loader: {
        label: {
          text: ``,
          active: false,
        },
        shortener: {
          text: ``,
          active: false,
        },
      },
      modal: {
        labelIntegrationHelp: false,
        shortenerIntegrationHelp: false,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      var data = await api.get(`slot/integration/${this.slotCode}`);

      if (data.labelData != null && data.registrarData != null) {
        this.labelIntegration.enabled = data.labelEnabled;
        var labelData = this.safeJsonParse(data.labelData);
        var registrarData = this.safeJsonParse(data.registrarData);

        const defaultLabelData = this.parameter.labelList.find(label => label.provider === labelData.provider);
        const defaultRegistrarData = this.parameter.registrarList.find(
          registrar => registrar.provider === registrarData.provider,
        );

        defaultLabelData.fields.forEach(field => {
          var value = labelData.fields.find(dataField => dataField.key === field.key).value;
          field.value = value;
        });

        this.labelIntegration.labelData = defaultLabelData;

        defaultRegistrarData.fields.forEach(field => {
          var value = registrarData.fields.find(dataField => dataField.key === field.key).value;
          field.value = value;
        });

        this.labelIntegration.registrarData = defaultRegistrarData;
      }

      if (data.shortenerData != null) {
        this.shortenerIntegration.enabled = data.shortenerEnabled;
        var shortenerData = this.safeJsonParse(data.shortenerData);

        const defaultShortenerData = this.parameter.shortenerList.find(
          shortener => shortener.provider === shortenerData.provider,
        );
        defaultShortenerData.fields.forEach(field => {
          var value = shortenerData.fields.find(dataField => dataField.key === field.key).value;
          field.value = value;
        });

        this.shortenerIntegration.shortenerData = defaultShortenerData;
      }
    },
    copyTemplate() {},
    async validateLabel() {
      try {
        var result = await api.post(`integration/validation/label`, this.labelIntegration.labelData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    async validateRegistrar() {
      try {
        var result = await api.post(`integration/validation/registrar`, this.labelIntegration.registrarData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    async validateShortener() {
      try {
        this.shortenerIntegration.loaderShortener = true;
        var result = await api.post(`integration/validation/shortener`, this.shortenerIntegration.shortenerData);
        return result;
      } catch (error) {
        throw error;
      }
    },
    async saveLabelIntegration() {
      if (this.labelIntegration.enabled) {
        let labelFields = Object.values(this.labelIntegration.labelData.fields).filter(
          x => x.value == null || x.value == "",
        );

        if (labelFields.length > 0) {
          this.showToast(`error`, `Please fill all the LABEL INTEGRATION fields`);
          return;
        }

        let registrarFields = Object.values(this.labelIntegration.labelData.fields).filter(
          x => x.value == null || x.value == "",
        );

        if (registrarFields.length > 0) {
          this.showToast(`error`, `Please fill all the REGISTRAR INTEGRATION fields`);
          return;
        }
      }

      this.loader.label.active = true;

      try {
        if (this.labelIntegration.enabled) {
          this.loader.label.text = `Validate Label Credential Data...`;
          let labelValidated = await this.validateLabel();
          if (!labelValidated) {
            this.showToast(`error`, `Label Credential Data is not valid`);
            return;
          }

          this.loader.label.text = `Validate Registrar Credential Data...`;
          let registrarValidated = await this.validateRegistrar();
          if (!registrarValidated) {
            this.showToast(`error`, `Registrar Credential Data is not valid`);
            return;
          }
        }

        this.loader.label.text = `Saving Label Integration...`;
        await api.post(`slot/integration/label`, {
          labelEnabled: this.labelIntegration.enabled,
          labelData: this.labelIntegration.labelData,
          registrarData: this.labelIntegration.registrarData,
          slotCode: this.slotCode,
        });
        this.loader.label.text = `Saved Successfully`;
        this.showToast(`success`, `Label Integration Saved Successfully`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.label.active = false;
      }
    },
    async saveShortenerIntegration() {
      if (this.shortenerIntegration.enabled) {
        let fields = Object.values(this.shortenerIntegration.shortenerData.fields).filter(
          x => x.value == null || x.value == "",
        );

        if (fields.length > 0) {
          this.showToast(`error`, `Please fill all the fields`);
          return;
        }
      }

      this.loader.shortener.active = true;

      try {
        if (this.shortenerIntegration.enabled) {
          this.loader.shortener.text = `Validate Credential Data...`;

          let shortenerValidated = await this.validateShortener();
          if (!shortenerValidated) {
            this.showToast(`error`, `Shortener Credential Data is not valid`);
            return;
          }
        }

        this.loader.shortener.text = `Saving Shortener Integration...`;

        await api.post(`slot/integration/shortener`, {
          shortenerEnabled: this.shortenerIntegration.enabled,
          shortenerData: this.shortenerIntegration.shortenerData,
          slotCode: this.slotCode,
        });

        this.loader.shortener.text = `Saved Successfully`;
        this.showToast(`success`, `Shortener Integration Saved Successfully`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader.shortener.active = false;
      }
    },
    safeJsonParse(jsonString) {
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return null;
      }
    },
  },
};
